import type { AgenticLogicSurface } from "../../../dtos/agentic-logic/surface";

/**
 * Shared ceiling for validation invocations and placement budgets. The
 * template runner's 30-second Lambda timeout leaves room for startup and
 * response handling. Publish gates judge measured runtime against the rule's
 * surface budget; validation gets this ceiling to preserve diagnostic output.
 */
export const AGENTIC_LOGIC_RUNTIME_BUDGET_MAX_MS = 10000;

/** Only used when a template-runner caller omits timeoutBudgetMs. */
export const AGENTIC_LOGIC_TEMPLATE_RUNNER_DEFAULT_BUDGET_MS = 1000;

/**
 * Production evaluation caps include Lambda startup and SDK reads. Local
 * relaxation stays in the backend and is applied at call time.
 */
export const AGENTIC_LOGIC_SURFACE_BASE_CAP_MS = {
  checkout: AGENTIC_LOGIC_RUNTIME_BUDGET_MAX_MS,
  onsite: AGENTIC_LOGIC_RUNTIME_BUDGET_MAX_MS,
  "post-purchase": AGENTIC_LOGIC_RUNTIME_BUDGET_MAX_MS,
} as const satisfies Record<AgenticLogicSurface, number>;

/**
 * Chain-cost gate allowance for work before and after rule execution.
 * Derived as ceil((0.93ms warm CPU p95 + 165ms I/O) / 25) * 25.
 * Change only with the evidence in docs/agentic-logic/fleet-capacity.md.
 * Serving uses an absolute deadline, so it must not subtract this again.
 */
export const AGENTIC_LOGIC_BROKER_OVERHEAD_MS = 175;

/** Average three retries only when a scenario misses its runtime budget. */
export const AGENTIC_LOGIC_RUNTIME_RETRY_COUNT = 3;
